import clientConfigurationProvider from "../../../../../providers/clientConfigurationProvider";

const getProductLink = ({ variantId, productId, ctaRef }) => {
  const { siteRootPath } = clientConfigurationProvider();
  const link = `${siteRootPath}prd/${productId}?CTARef=${ctaRef}${
    variantId ? `#variantId-${variantId}` : ""
  }`;

  return link;
};

export default getProductLink;
